import IdleState from './idle_state';
import State from './state';

export default class SelectKeepState extends State {
  constructor (context, points) {
    super(context);
    this.points = points;
    this.points.forEach(p => p.select());
  }

  mouseUp (context, e) {
    this.dispose();
    return new IdleState(context);
  }

  dispose () {
    this.points.forEach(p => p.unselect());
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/fillet/states/select_keep_state.js